import { FileText, Trash2 } from "lucide-react";

interface UploadProgressProps {
  readonly file: File;
  readonly progress: number;
  readonly ready: boolean;
  readonly onRemove: () => void;
  readonly onConvert: () => void;
}

function formatBytes(value: number): string {
  return value >= 1024 * 1024
    ? `${(value / 1024 / 1024).toFixed(2)} MiB`
    : `${Math.max(1, Math.round(value / 1024))} KiB`;
}

export function UploadProgress({
  file,
  progress,
  ready,
  onRemove,
  onConvert,
}: UploadProgressProps) {
  return (
    <section className="status-panel" aria-live="polite">
      <div className="selected-file-row">
        <span className="file-kind-icon pdf">
          <FileText size={28} />
        </span>
        <span className="file-copy">
          <strong>{file.name}</strong>
          <small>{formatBytes(file.size)}</small>
        </span>
        <button
          className="icon-button"
          type="button"
          onClick={onRemove}
          aria-label="删除已上传文件"
        >
          <Trash2 size={19} />
        </button>
      </div>
      <div className="progress-track" aria-label="上传进度">
        <span style={{ width: `${ready ? 100 : progress}%` }} />
      </div>
      <p className="status-caption">
        {ready ? "PDF 校验完成，可以开始转换" : `正在直传到 R2… ${progress}%`}
      </p>
      {ready ? (
        <button
          className="primary-action wide"
          type="button"
          onClick={onConvert}
        >
          开始转换
        </button>
      ) : null}
    </section>
  );
}
